
    import {Component, Vue} from 'vue-property-decorator';
    import {nil} from '@/common';
    import {DateTime} from 'luxon';
    import {getZonedBookingDate} from '@/utils';

    @Component({
    components: {
    },
})
export default class BookingCalculateCheckInOutMixin extends Vue {
    public booking: any;
    public checkInBuffer = 15;

    get expectedCheckInTime() {
        if (nil(this.booking)) { return null; }
        return DateTime.fromISO(this.booking.date);
    }
    get expectedCheckOutTime() {
        if (nil(this.booking)) { return null; }
        return this.expectedCheckInTime.plus({hours: this.booking.duration});
    }
    get expectedZonedCheckInTime(){
        if (nil(this.booking)) { return null; }
        return getZonedBookingDate(this.booking);
    }
    get expectedZonedCheckOutTime(){
        if (nil(this.booking)) { return null; }
        return this.expectedZonedCheckInTime.plus({hours:this.booking.duration});
    }
    get canEditBookingCheckInOut() {
        if (nil(this.expectedCheckInTime)) { return false; }
        if (nil(this.booking.assignedVendor)) { return false; }
        return this.timeIsWithinMinutes(this.expectedCheckInTime, 0) <= 0;
    }

    public timeIsWithinMinutes(time: DateTime, minutes: number) {
        const diff = (time.diffNow(['minutes']) as any).minutes;
        if (Math.abs(diff) > minutes) {
            return diff > 0 ? 1 : -1;
        }
        return 0;
    }
    public timeIsWithinMinutesOfOtherTime(time: DateTime, otherTime: DateTime, minutes: number) {
        const diff = (time.diff(otherTime, ['minutes']) as any).minutes;
        if (Math.abs(diff) > minutes) {
            return diff > 0 ? 1 : -1;
        }
        return 0;
    }
    public friendlyCheckInOutTime(time): string {
        const t = DateTime.fromISO(time);
        const diff = (t.diffNow(['seconds']) as any).seconds;
        if (10 > Math.abs(diff)) { return 'Just Now'; }
        const maxCheckIn = -(60 * 60 * 12);
        if (diff > maxCheckIn) { return t.toLocal().toLocaleString(DateTime.DATETIME_MED); }
        return `${t.toLocal().toLocaleString(DateTime.TIME_SIMPLE)}`;
    }
}
